export const isNonEmptyArray = (value) => {
  return Array.isArray(value) && value.length > 0;
};

export const isNonEmptyDateRange = (value) => {
  return Array.isArray(value) && !!(value[0] || value[1]);
};

export const isNonEmptyString = (value) => {
  return typeof value === 'string' && value.length > 0;
};
